import { RubberSegment, AnimatedReveal } from "@iq/models";
import { formatTimeRange } from "../../utils/time";
import styles from "./AppointmentList.module.css";

const MODES = [
    { value: "pending", label: "Pending" },
    { value: "completed", label: "Completed" },
];


function AppointmentList({ appointments, mode, onModeChange, selectedDate, todayKey, selectedKey, onSelect, getKey }) {
    return (
        <section className={styles.list} aria-label="Appointments">
            <RubberSegment
                items={MODES}
                value={mode}
                onChange={onModeChange}
                size="sm"
                trackColor="var(--surface-soft)"
                thumbColor="var(--action-primary)"
                textColor="var(--fg-muted)"
                activeTextColor="var(--fg-on-action-primary)"
                aria-label="Appointment list filter"
            />
            {appointments.length === 0 ? (
                <p className={styles.empty}>No {mode} appointments on this day.</p>
            ) : (
                <>
                    <ul className={styles.items}>
                        {appointments.map((appointment) => {
                            const key = getKey(appointment);
                            return (
                                <li key={key} data-reveal>
                                    <button
                                        type="button"
                                        className={`${styles.item} ${key === selectedKey ? styles.itemSelected : ""}`}
                                        onClick={() => onSelect(appointment)}
                                    >
                                        <div className={styles.itemLeft}>
                                            <strong className={styles.name}>
                                                {appointment.customer?.name || appointment.customer_name || "Appointment"}
                                            </strong>
                                            <span className={styles.when}>
                                                {formatTimeRange(appointment.start_time, appointment.end_time)}
                                            </span>
                                        </div>


                                        <span className={styles.status}>{appointment.status || "pending"}</span>
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </>

            )}
        </section>
    );
}

export default AppointmentList;
